var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',_vm._g(_vm._b({},'v-alert',_vm.$attrs,false),_vm.$listeners),[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"grow py-0"},[_vm._t("default")],2),_c('v-col',{staticClass:"shrink py-0"},[_vm._t("action")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }